export class EmailPreviewResponse {

    public constructor(init?: Partial<EmailPreviewResponse>) {
        if (init) {
          Object.assign(this, init);
        }
      }

    /** The standard shipment-notification email. */
    public subject: string = '';
    public htmlBody: string = '';
    public recipients: string[] = [];
    public senderEmail: string = '';

    /**
     * The separate expediting / missing-items email preview, rendered when the
     * request carried missing items (`missingItems`) and `expeditingEmailData`.
     * Same shape as the standard fields above. Absent when nothing is missing
     * or the backend has not implemented the render yet — the frontend falls
     * back to a locally-built placeholder in that case.
     */
    public expeditingEmailPreview?: EmailPreviewResponse;

}